export var checkIsRtlDirection = function () { return document.documentElement.getAttribute('dir') === 'rtl'; };
